export const GET_SIGNED_URL = 'getSignedUrl'
export const UPLOAD_TO_SIGNED_URL = 'uploadFileToSignedUrl'
